export default {
    primary: '#1D4E89',
    lightPrimary: '#d9ebfd',
    secondary: '#F79256',
    lightSecondary: '#eec2ae',
    inactive: '#E0E4DA',
    background: '#fff9ed',
    dark: '#000814'
}
